<template>
  <div class="section-radio me-1" :class="radioClass" @click="goToSection()">
    <div class="section-radio__bubble">
      <AppIcon v-if="isSectionCompleted" icon="complete" />
    </div>
    <div class="section-radio__text">{{ section.section_number }}</div>
  </div>
</template>

<script>
import entityProgress from '../mixins/entityProgress'

export default {
  mixins: [entityProgress],
  props: {
    currentSection: {
      type: Object,
      required: true,
    },
    section: {
      type: Object,
      required: true,
    },
    chapterDisplayOrder: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    currentQuestionIds() {
      return this.section.question_ids
    },
    survey() {
      return this.$page.props.survey
    },
    isCurrentSection() {
      return this.currentSection.id === this.section.id
    },
    isSectionCompleted() {
      return this.availableProgress === this.questionsProgress
    },
    isSectionStarted() {
      return this.questionsProgress != 0
    },
    radioClass() {
      let cssClass = ' '
      if (this.isCurrentSection) {
        cssClass += 'section-radio--active '
      }
      if (this.isSectionCompleted) {
        return cssClass + 'section-radio--complete'
      }
      if (this.isSectionStarted) {
        cssClass += 'section-radio--in-progress '
      }
      return cssClass
    },
  },
  methods: {
    goToSection() {
      if (this.isCurrentSection) {
        return
      }
      return this.$inertia.visit(
        this.$route('survey.user.show', {
          id: this.survey.id,
        }),
        {
          data: {
            chapitre: this.chapterDisplayOrder,
            section: this.section.display_order,
          },
          preserveScroll: false,
          replace: false,
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.section-radio {
  --font-size: 0.9rem;
  --bubble-size: calc(var(--font-size) * 1.4);
  --horizontal-padding: calc(var(--font-size) * 0.9);
  --bubble-border-radius: calc(var(--font-size) * 7.5);
  display: flex;
  place-content: center;
  flex-direction: column-reverse;
  place-items: center;

  border-radius: 0.375em;
  padding: calc(var(--bubble-size) / 2) var(--horizontal-padding);
  margin: calc(var(--bubble-size) / 2) 0;

  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border: solid 0.1em transparent;

  &:hover,
  &:focus-within {
    background: hsla(90deg, 90%, 100%, 0.25);
    border-color: var(--gdep_color__secondary-dark);
  }
  &:active {
    border-color: var(--gdep_color__secondary-dark);
    background-color: hsla(0, 100%, 100%, 0.99);
  }
  &__bubble {
    width: var(--bubble-size);
    height: var(--bubble-size);
    border-radius: var(--bubble-border-radius);
    background: linear-gradient(
      to right bottom,
      var(--bs-primary),
      var(--bs-secondary)
    );
    position: relative;
    &:before {
      content: '';
      display: inline-block;
      width: inherit;
      height: inherit;
      border-radius: inherit;
      background: var(--bs-gray-400);
      transform: scale(1.1);
      transition: 0.3s;
    }
  }
  &__text {
    color: hsl(0, 0%, 60%);
    text-align: center;
    text-transform: uppercase;
    font-size: var(--font-size);
    font-weight: 500;
    transition: 0.3s;
  }

  &--active {
    background-color: hsla(0, 100%, 100%, 0.79);
    transition: background-color 0.3s ease-in-out;

    &:hover,
    &:focus-within {
      background-color: hsla(0, 100%, 100%, 0.99);
    }
    .section-radio {
      &__text {
        color: hsl(0, 0%, 40%);
        font-weight: 500;
      }
    }
  }
  &--complete {
    .section-radio {
      &__bubble {
        position: relative !important;
        background: linear-gradient(
          to right bottom,
          var(--gdep_color__secondary-dark),
          var(--gdep_color__secondary)
        );
        &:before {
          position: relative !important;
          transform: scale(0);
        }
        color: white;
        svg {
          transform: scale(0.8);
          position: absolute;
          top: 20%;
          left: 20%;
        }
      }
      &__text {
        color: hsl(0, 0%, 40%);
        font-weight: 600;
      }
    }
  }
  &--in-progress {
    .section-radio {
      &__bubble {
        background: linear-gradient(
          to right bottom,
          var(--gdep_color__secondary-dark),
          var(--gdep_color__secondary)
        );
        &:before {
          transform: scale(0);
        }
      }
      &__text {
        color: hsl(0, 0%, 40%);
        font-weight: 400;
      }
    }
  }
}
</style>
